import { render, staticRenderFns } from "./DisclosureManual.vue?vue&type=template&id=8101a8ea&scoped=true"
import script from "./DisclosureManual.vue?vue&type=script&lang=js"
export * from "./DisclosureManual.vue?vue&type=script&lang=js"
import style0 from "./DisclosureManual.vue?vue&type=style&index=0&id=8101a8ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8101a8ea",
  null
  
)

export default component.exports